import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import UtilSequence from "@/utils/UtilSequence.mjs";

export default {

    async criaParcela(parcelaValores = {}){

        let pedidoDeCompraParcela;

        try{

            parcelaValores = {
                ...parcelaValores,
                status: "Em Desenvolvimento",
            }

            pedidoDeCompraParcela = await ERP.postOne(Schema.PEDIDO_DE_COMPRA_PARCELAS, parcelaValores);
            if(pedidoDeCompraParcela.status != 200){
                throw pedidoDeCompraParcela;
            }

            console.log(pedidoDeCompraParcela);

        }catch(e){

            console.log(e);
            return pedidoDeCompraParcela;

        }

        return pedidoDeCompraParcela;

    },

    async criaParcelas(parcelasValores = []){

         let pedidoDeCompraParcelas = {
            data: [],
            status: 200
        };

        try{

            pedidoDeCompraParcelas.data = await UtilSequence.each({
                list: parcelasValores,
                callback: async (parcelaValor)=>{

                    let pedidoDeCompraParcela = await this.criaParcela(parcelaValor);
                    if(pedidoDeCompraParcela.status != 200){
                        throw pedidoDeCompraParcela;
                    }

                    return pedidoDeCompraParcela.data;

                }
            });

            console.log(pedidoDeCompraParcelas);

        }catch(e){

            console.log(e);
            pedidoDeCompraParcelas.status = 500;
            return pedidoDeCompraParcelas;

        }

        return pedidoDeCompraParcelas;

    },

    async alteraParcela(parcelaValores = {}){

        let pedidoDeCompraParcela;

        try{

            pedidoDeCompraParcela = await ERP.patchOne(Schema.PEDIDO_DE_COMPRA_PARCELAS, parcelaValores);
            if(pedidoDeCompraParcela.status != 200){
                throw pedidoDeCompraParcela;
            }

            console.log(pedidoDeCompraParcela);

        }catch(e){

            console.log(e);
            return pedidoDeCompraParcela;

        }

        return pedidoDeCompraParcela;

    },

    async alteraParcelas(parcelasValores = []){

        let pedidoDeCompraParcelas;

        try{

            pedidoDeCompraParcelas = await ERP.patchMany(Schema.PEDIDO_DE_COMPRA_PARCELAS, parcelasValores);
            if(pedidoDeCompraParcelas.status != 200){
                throw pedidoDeCompraParcelas;
            }

            console.log(pedidoDeCompraParcelas);

        }catch(e){

            console.log(e);
            return pedidoDeCompraParcelas;

        }

        return pedidoDeCompraParcelas;

    },

}